import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Radio as antdRadio } from 'antd';
import { injectIntl } from 'react-intl';

const notActiveColor = p => p.dark ? '#fff' : p.theme.colors.themeSecondary;

const activeBackgroundColor = p =>
  `${p.activeColor || p.theme.colors[p.dark ? 'darkThemeSecondary' : 'themeSecondary']
  }`;

const RadioGroup = styled(antdRadio.Group)`
  .ant-radio-button-wrapper {
    color: ${notActiveColor};
    background-color: transparent;
    border-color: transparent !important;
    border-radius: 30px !important;
    padding: 0 0.6em;
    font-weight: 500;
  }
  .ant-radio-button-wrapper-checked {
    background-color: ${activeBackgroundColor};
    box-shadow: none !important;
    color: #fff;
  }
  .ant-radio-button-wrapper:hover {
    background-color: #b9c9e1;
    color: ${notActiveColor};
  }
  .ant-radio-button-wrapper-checked:hover {
    border-color: none;
  }
  .ant-radio-button-wrapper:not(:last-child) {
    margin-right: 0.25em;
  }
  .ant-radio-button-wrapper:not(:first-child)::before {
    display: none !important;
  }
`;

const RadioButton = styled(antdRadio.Button)`
  background-color: ${p => p.theme.colors.themeSecondary};
  box-shadow: none;
`;

export const ToggleLabel = styled.label`
  margin-right: 5px;
  font-weight: 400;
  font-size: 12px;
`;

const renderItems = (props) => {
  const { items, customRender, shouldTranslate = false, intl } = props;
  if (customRender) {
    return customRender(props);
  }
  if (!items) {
    return null;
  }
  return items?.map(item =>
    <RadioButton key={item.value} value={item.value}>
      {shouldTranslate ? intl.formatMessage({ id: item.text }) : item.text}
    </RadioButton>,
  );
};

const ToggleFilter = ({
  value = '',
  label,
  onChange,
  dark = false,
  activeColor,
  ...rest
}) =>
  <>
    {label && <ToggleLabel>{label}</ToggleLabel>}
    <RadioGroup dark={dark} onChange={onChange} value={value} activeColor={activeColor}>
      {renderItems(rest)}
    </RadioGroup>
  </>;
ToggleFilter.propTypes = {
  items: PropTypes.array,
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  shouldTranslate: PropTypes.bool,
  intl: PropTypes.object.isRequired,
  dark: PropTypes.bool,
  customRender: PropTypes.func,
  activeColor: PropTypes.string,
};

export default injectIntl(ToggleFilter);
